import { Phrases } from '@shared/model/locales.model';

export default {
  EditGateToGate: {
    EditTime: 'تعديل الوقت',
    ConfirmEdit: 'عدل وأكد أنك متأكد من إجراء هذا التغيير.',
    AccurateTime: 'الوقت الدقيق',
  },
  GateDefinition: {
    inBound: 'الوارد',
    outBound: 'الصادر',
    both: 'كليهما',
    temperatureControl: 'التحكم في درجة الحرارة',
    temperatureControlText: 'إذا لم يتم اختياره، يعني أن درجة حرارة البوابة طبيعية.',
    gateName: 'إسم البوابة',
    referenceID: 'معرف المرجع',
    truckClassify: 'تصنيف الشاحنة',
    Frozen: 'مجمد',
    Chiller: 'مبرِّد',
    GatesManagement: 'إدارة البوابات',
    addGateDesc: 'اضغط على "إضافة بوابة" لإعداد بوابات الموقع',
    addGate: 'إضافة بوابة',
    gates: 'البوابات',
    DeviceDistance: 'مسافة الجهاز',
  },
  GateToGate: {
    DateModifyingHistory: 'سجل تعديل التاريخ',
    DateUpdated: '* بواسطة [{{name}}] - كان [{{date}}]',
    ShipmentLogs: 'سجل الشاحنة',
    SentEmail: 'تم إرسال البريد الإلكتروني',
    WithAttachment: 'مع مرفقات',
  },
  ShippingCard: {
    Clients: 'عملاء',
    Orders: 'طلبات',
  },
  deliveryNote: {
    uploadWaitingCharge: 'تحميل دليل رسوم الانتظار',
  },
  PlateNumber: {
    External: 'خارجية',
  },
  StatusCard: {
    NoteThatOverdueDays:
      'يرجى ملاحظة أن أيام الاستحقاق المتأخرة للفواتير تُحدث الساعة 01:00 صباحاً يومياً.',
  },
  Enum: {
    WccIntegrationStatusType: {
      WAITING_ASSIGNMENT: 'في انتظار المهمة',
      INTEGRATED: 'متكامل',
      INTEGRATION_FAILED: 'فشل التكامل',
      INTEGRATION_IN_PROGRESS: 'التكامل قيد التقدم',
      INTEGRATION_CANCELED: 'تم إلغاء التكامل',
      CANCELATION_FAILED: 'فشل الالغاء',
    },
    ShipmentHeadedStatus: {
      RIGHT_HEADED: 'اتجاه صحيح',
      WRONG_HEADED: 'اتجاه خاطئ',
    },
  },
  usersList: {
    button: {
      generateComplexPassword: 'إنشاء كلمة مرور معقدة',
    },
  },
  'ShipmentAssignment.OverrideDetected': 'تم الكشف عن تجاوز',
  'ShipmentAssignment.HasRunningShipment': '  لدية رحلة قائمة  ',
  'ShipmentAssignment.From': ' من  ',
  'ShipmentAssignment.Kindly': ' برجاء العلم ان  ',
  'ShipmentAssignment.TheDriver': ' هذا السائق ',
  'ShipmentAssignment.TheTruck': ' هذه الشاحنة ',
  'ShipmentAssignment.To': 'إلى',
  'ShipmentAssignment.CloseShipment': 'هل تريد اغلاق الشحنة',
  'ShipmentAssignment.ThisShipment': 'هذه الشحنة',
  'ShipmentAssignment.ThoseShipments': 'تلك الشحنات  ',
  'ShipmentAssignment.WillStart': 'ستبدأ عندما يتم تسليم ',
  'ShipmentAssignment.Shipment': 'الشحنة',
  'ShipmentAssignment.SuccessfullyDelivered': 'بنجاح',
  'ShipmentAssignment.ConfirmOverride': 'تأكيد التجاوز',
  'ShipmentAssignment.JustAssign': 'تعيين فقط',
  'ShipmentAssignment.AssignAndAutoStart': 'تعيين وبداية',
  'ShipmentAssignment.Justification': 'الأسباب',
  'ShipmentAssignment.ErrorMessageRequired': 'حقل مطلوب',
  'ShipmentAssignment.Hint': 'تلميح',
  CancelAll: 'إلغاء الكل',
  NoOrdersAddedYet: 'لم يتم اختيار طلبات',
  'UserStatus.ACTIVE': 'نشط',
  'UserStatus.INACTIVE': 'غير نشط',
  'UserStatus.All': 'الكل',
  PricingMethod: 'طريقة التسعير',
  SelectUnitType: 'اختر نوع الوحدة',
  PER_TRADE_LANE: 'حسب خط النقل',
  PER_UNIT: 'حسب الوحدة',
  TON: 'طن',
  ZeroPrices: 'أسعار الشحن صفر',
  UseZeroPrices: 'استخدم أسعار الشحن صفر',
  UseDefaultPrices: 'استخدم أسعار الشحن الافتراضية',
  CustomerPartOfOrganization: 'هذا العميل جزء من منظمة، ولا يمكنك تغيير طريقة التسعير.',
  ConfirmationChangePricingMethod: 'هل أنت متأكد أنك تريد تغييره؟',
  ConfirmationMessageChangePricingMethod:
    'أنت على وشك تغيير طريقة الدفع من {{pricingMethodBefore}} إلى {{pricingMethodAfter}}. سيؤدي هذا التغيير إلى تحديث جميع أسعار خطوط التجارة للعميل.',
  YesChange: 'نعم، غيّر',
  KeepCurrent: 'الإبقاء على الوضع الحالي',
  CustomerType: 'نوع العميل',
  Saas: 'SaaS',
  Taas: 'TaaS',
  Both: 'كلاهما',
  SaaSFees: 'رسوم SaaS',
  SearchUser: 'اسم المستخدم أو البريد الإلكتروني',
  Title: 'المجمّع',
  MovedTitle: 'تم نقل لوحة تحكم B2C',
  Description:
    'لوحة إدارة B2C أصبحت متاحة الآن على منصة منفصلة. يرجى استخدام الرابط أدناه للوصول إليها.',
  LoginInfo: 'يمكنك تسجيل الدخول باستخدام نفس البريد الإلكتروني أو رقم الهاتف وكلمة المرور.',
  NewLocation: 'الموقع الجديد',
  Url: 'lastmile.madar.app',
  BookmarkNote:
    'للاستمرار في الاستمتاع بوصول غير منقطع، يرجى تحديث الإشارات المرجعية والروابط المحفوظة.',
  GoButton: 'الانتقال إلى B2C Admin',
  OpenNewTab: 'فتح في تبويب جديد',
  Footer: 'تم إجراء هذا التغيير لتحسين الأداء وتجربة المستخدم',
  RenewPasswordReminder: 'تذكير بتجديد كلمة المرور',
  NoticeTitle: 'تنبيه: ستنتهي صلاحية كلمة مرورك قريبًا',
  NoticeBody:
    'ستنتهي صلاحية كلمة مرورك خلال {{days}} أيام. يمكنك التجديد في أي وقت من إعدادات حسابك.',
  ReminderTitle: 'تذكير: ستنتهي صلاحية كلمة مرورك قريبًا',
  ReminderBody: 'ستنتهي صلاحية كلمة مرورك خلال {{days}} أيام. نوصي بالتجديد مبكرًا لتجنب الانقطاع.',
  UrgentTitle: 'عاجل: ستنتهي صلاحية كلمة مرورك قريبًا!',
  UrgentBodyDays:
    'لم يتبق سوى {{days}} يوم/أيام قبل انتهاء صلاحية كلمة مرورك. جدد فورًا لتجنب الانقطاع.',
  UrgentBodyExpired: 'انتهت صلاحية كلمة مرورك. جدد الآن لاستعادة الوصول إلى جميع الخدمات.',
  DaysRemainingLabel: 'متبقي {{days}} يوم/أيام',
  PasswordExpiredLabel: 'انتهت صلاحية كلمة المرور',
  Expired: 'منتهي',
  DaysLeft: 'أيام متبقية',
  RemindMeLater: 'ذكرني لاحقًا',
  RenewNow: 'جدد كلمة المرور الآن',
  WaitingChargeConfig: 'إعدادات رسوم الانتظار',
  EnableWaitingTimeChargesPolicy: 'تفعيل سياسة رسوم وقت الانتظار',
  EnableWaitingTimeChargesPolicyDesc: 'تفعيل أو تعطيل رسوم الانتظار لتأخيرات الاستلام والتسليم.',
  FreeWaitingTime: 'وقت الانتظار المجاني',
  FreeWaitingTimeTooltip: 'وقت الانتظار المجاني قبل تطبيق الرسوم',
  HourlyRate: 'السعر بالساعة',
  HourlyRateTooltip: 'الرسوم لكل ساعة بعد انتهاء الوقت المجاني',
  MaximumWaitingHours: 'الحد الأقصى لساعات الانتظار',
  MaximumWaitingHoursTooltip: 'الحد الأقصى لساعات الانتظار القابلة للفوترة قبل التحويل إلى السعر اليومي',
  DailyRate: 'السعر اليومي',
  DailyRateTooltip: 'رسوم الانتظار ليوم كامل',
  Hour: 'ساعة',
  Export: 'تصدير',
  NoStatementsFound: 'لا توجد كشوف حسابات حتى الان',
  TransactionDate: 'تاريخ المعاملة',
  ReferenceNumber: 'الرقم المرجعي',
  DueDate: 'تاريخ الاستحقاق',
  OverdueDays: 'أيام التأخير',
  Debit: 'مدين',
  Credit: 'دائن',
  Status: 'الحالة',
} as Phrases;
